import { Post } from "../interfaces/interfaces";
// use ISO format for dates to sort by newest effectievely: YYYY-MM-DD
export const posts: Post[] = [
  {
    id: 1,
    date: "2024-07-11",
    title:
      "Rythmes Africains et dialogues musicaux : Zied Zouari enchante Hammamet lors de la 58ème Édition du Festival ",
    excerpt:
      "La soirée du 11 juillet 2024 a offert au public du centre culturel international de Hammamet une expérience musicale inoubliable.Ils ont été emportés par une vague de rythmes et de sonorités, orchestrés par le talentueux musicien tunisien Zied Zouari dans sa nouvelle création “Made in Africa”.",
    category: "Musicien.tn",
    link: "https://musicien.tn/alaune/rythmes-africains-et-dialogues-musicaux-zied-zouari-enchante-hammamet-lors-de-la-58eme-edition-du-festival/?fbclid=IwY2xjawJeaCFleHRuA2FlbQIxMAABHkMJPvR3PWCYqmQJZ-7o9NEgH8HOIonLZXXK6Lbat_tVw7fVs4IZYbal2ScI_aem_GFNh1cncVPGIPy2TXXUl1g",
    imageUrl: "/DSC07605.webp",
  },
  {
    id: 2,
    date: "2024-09-16",
    title:
      "La tournée Japonaise du groupe “Duplessy et les violons du Monde” : le violoniste Tunisien Zied Zouari, resplendit sur la scène Internationale",
    excerpt:
      "Le 15 septembre 2024, le groupe Duplessy et les violons du Monde a donné le coup d’envoi de sa tournée japonaise au Forest Hall d’Aichi, marquant le début d’une série de 10 concerts dédiés à la promotion de son album “The Road with you “, avec une sortie prévue pour le 29 janvier 2025 à La Cigale, Paris.",
    category: "Musicien.tn",
    link: "https://musicien.tn/alaune/la-tournee-japonaise-de-the-road-with-you-le-violoniste-tunisien-zied-zouari-resplendit-sur-la-scene-internationale/",
    imageUrl: "/Duplessy---violins.webp",
  },
  {
    id: 3,
    date: "2024-07-13",
    title:
      "Made in Africa est une peinture musicale africaine dirigée par le Tunisien Ziad Zouari",
    excerpt:
      "Chaque pièce connote un engagement ou une histoire telle que Orion, l’étoile qui guide les subsahariens sur le chemin du nord.",
    category: "alarab.co.uk",
    link: "https://alarab.co.uk/%D9%85%D8%A7%D9%8A%D8%AF-%D8%A5%D9%86-%D8%A3%D9%81%D8%B1%D9%8A%D9%83%D8%A7-%D9%84%D9%88%D8%AD%D8%A9-%D9%85%D9%88%D8%B3%D9%8A%D9%82%D9%8A%D8%A9-%D8%A3%D9%81%D8%B1%D9%8A%D9%82%D9%8A%D8%A9-%D9%8A%D9%82%D9%88%D8%AF%D9%87%D8%A7-%D8%A7%D9%84%D8%AA%D9%88%D9%86%D8%B3%D9%8A-%D8%B2%D9%8A%D8%A7%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%B1%D9%8A?fbclid=IwY2xjawJeZ-JleHRuA2FlbQIxMAABHt8-1ZntY9zupbLjyQHCSJ1s151gSMqjyjofK3gmT-lH8GpKbqtHs7RWqB7Q_aem_nx8qkxWiJ0OEu8TId7p9NA&mibextid=oEMz7o",
    imageUrl: "/photo.webp",
  },
  {
    id: 4,
    date: "2024-07-13",
    title: "En extase avec Zied Zouari",
    excerpt:
      "Il serait à la fois facile et vain de parler de voyage musical à travers le spectacle Made in Africa du violoniste virtuose Zied Zouari, tenu au Festival International de Hammamet jeudi 11 juillet 2024. Il faudrait plutôt parler d’une exploration dans le temps, la Tunisie, comme l’a bien précisé l’artiste, s’appelait, il y a 1500 ans, Ifriqiya, la petite Afrique, nom qui sera attribué à tout le continent.",
    category: "souffleinedit.com",
    link: "https://souffleinedit.com/musique-art-du-spectacle/extase-zied-zouari/?fbclid=IwY2xjawJeaXVleHRuA2FlbQIxMAABHh-eHgvkwDaA9mbWIqJ04rqfd_9mj7zPntJrB4K8QWz5wpn12ar_mo-_JHMD_aem_MIe7XUYAelyvalhSkSxbww",
    imageUrl: "/image-1_18.webp",
  },
  {
    id: 5,
    date: "2019-07-24",
    title:
      "FIC 2019: Soirée d’expérimentation musicale avec Zied Zouari, Nidhal Yahiaoui et Lina Ben Ali",
    excerpt:
      "Le FIC dans sa 55ème édition a voulu démontrer que la programmation des jeunes artistes tunisiens au Théâtre romain de Carthage est un réel investissement dont les bénéfices sont immédiats. En témoigne la soirée du mardi 23 juillet 2019 avec la participation de Zied Zouari, Nidhal Yahiaoui et Lina Ben Ali qui ont assuré tous les trois une soirée spéciale au bonheur de leurs fans venus nombreux les encourager.",
    category: "africanmanager.com",
    link: "https://africanmanager.com/fic-2019-soiree-dexperimentation-musicale-avec-zied-zouari-nidhal-yahiaoui-et-lina-ben-ali/?fbclid=IwY2xjawJeaulleHRuA2FlbQIxMQABHilxw2UYqELZ1Zbhn6OEl5Fyx0rrbNOFHH7siVG-rbUiS3ZqjFKsiWlLy5WW_aem_yWWoxzt-GVKSi_BPMnPSWw",
    imageUrl: "/festival-696x696.webp",
  },
  {
    id: 6,
    date: "2024-10-17",
    title:
      "«Le concert des continents : Cordes en Harmonie» à Yasmine Hammamet : Une rencontre musicale au carrefour des cultures",
    excerpt:
      "«La fondation Hasdrubal pour la culture et les arts Mohamed Amouri» et son directeur musical Laurent Jost invitent sur scène une floppée de musiciens professionnels et émergents, issus  de toutes les nationalités du monde pour «Le concert des continents». L’événement musical rime avec résonances et mélodies occidentales et orientales. Les cordes à instruments s’apprêtent à fusionner.",
    category: "lapresse.tn",
    link: "https://lapresse.tn/2024/10/17/le-concert-des-continents-cordes-en-harmonie-a-yasmine-hammamet-une-rencontre-musicale-au-carrefour-des-cultures/?fbclid=IwY2xjawJebMhleHRuA2FlbQIxMQABHq4yJykUs4MpQQ50ONor3mZLrHUy74_eaGzdrI8t9kErzoMzZb77SAYIEFeX_aem_bxs3d84OYwFvvmjP6cRbBQ",
    imageUrl: "/le-concert-des-continents-01.webp",
  },
  {
    id: 7,
    date: "2024-06-28",
    title: "Zied Zouari Bine el Binine",
    excerpt:
      "Le directeur artistique du spectacle de clôture du Festival arabe de la radio et de la télévision musicale, Zied Zouari, nous parle du spectacle Ruh Al-Arab, de la création de l'Orchestre symphonique arabe et de nombreux autres détails.",
    category: "BinElBinin",
    link: "https://www.facebook.com/BinElBinin/videos/351133701418888/",
    imageUrl: "/485118576_1163527591899405_7227321267193089362_n.webp",
  },
  {
    id: 8,
    date: "2023-06-15",
    title:
      "L'émission Marassi : Bab Al-Diwan, réunit les musiciens Zied Zouari (violon) et Ghassan Fendri (guitare).",
    excerpt:
      "L'épisode d'aujourd'hui de l'émission Marassi est consacré à la découverte d'un projet musical venant de la ville historique de Sfax, en Tunisie, intitulé Bab Al-Diwan. Ce projet réunit les musiciens Zied Zouari (violon) et Ghassan Fendri (guitare)...",
    category: " Monte Carlo Doualiya",
    link: "https://www.facebook.com/share/v/16GEvLW4hK/",
    imageUrl: "/481711906_1153203182931846_6834928654635318864_n.webp",
  },
  {
    id: 9,
    date: "2024-11-05",
    title: "« Circles » de Zied Zouari enchante le public de Dar Sebastian",
    excerpt:
      "La 4éme rencontre « Les cordes de Dar Sebastian « organisée par le centre culturel international de hammamet, du 28 octobre au 03 novembre 2024 dans le cadre d’octobre musical se veut un espace de découverte, de diffusion et de transmission du répertoire musical au son d’un instrument phare, le violon. Cette manifestation a pris fin avec le concert « Circles » de Zied Zouari, une synthèse d’une longue réflexion autour du violon arabe contemporain.",
    category: "letemps.news",
    link: "https://letemps.news/2024/11/05/circles-de-zied-zouari-enchante-le-public-de-dar-sebastian/?sfnsn=mo&fbclid=IwY2xjawJedGhleHRuA2FlbQIxMQABHkxsGaPZC1cgCq7qwR567inOup_nXNYBOCsBAxMNZeygUXZVe-HHV-ObnpuH_aem_7TpFEpQvlAEaS7HgjWMIaQ",
    imageUrl: "/CSC_0080-1-1200x799.webp",
  },
    {
    id: 6,
    imageUrl: "/519957870_18392033287185342_38310652489898837_n.webp",
    date: "2025-07-24",
    title: "Ana chaabek",
    excerpt:
      "Ana Chaabek est une opérette Tunisienne qui rassemble cent artistes de toute la Tunisie. Elle raconte la beauté des territoires, allant du Sud au Nord et fait intervenir un orchestre symphonique, une Chorale d'enfants ainsi que 13 Chanteurs et chanteuses de grande envergure. Cette opérette, sous la direction de Zied Zouari, est le fruit de partenariat entre la télévision nationale tunisienne, la radio nationale tunisienne et l’Opéra de Tunis",
    category: "Al Maghreb",
    link: "https://ar.lemaghreb.tn/%D9%85%D9%82%D8%A7%D9%84%D8%A7%D8%AA-%D8%A7%D9%84%D9%85%D8%BA%D8%B1%D8%A8/item/115423-%D8%A7%D9%84%D9%81%D9%86%D8%A7%D9%86-%D8%B2%D9%8A%D8%A7%D8%AF-%D8%A7%D9%84%D8%B2%D9%88%D8%A7%D8%B1%D9%8A-%D9%84%D9%80-%D8%A7%D9%84%D9%85%D8%BA%D8%B1%D8%A8-%D8%A3%D9%86%D8%A7-%D8%B4%D8%B9%D8%A8%D9%83-%D8%A3%D9%88%D8%A8%D9%8A%D8%B1%D8%A7%D8%AA-%D9%88%D8%B7%D9%86%D9%8A%D8%A9-%D9%87%D8%AF%D9%8A%D8%A9-%D9%84%D8%AA%D9%88%D9%86%D8%B3-%D9%81%D9%8A-%D8%B9%D9%8A%D8%AF-%D8%A7%D9%84%D8%AC%D9%85%D9%87%D9%88%D8%B1%D9%8A%D8%A9"
  }
];
